// import node module libraries
import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// import layouts
import ScrollToTop from 'layouts/dashboard/ScrollToTop';
import AllRoutes from 'layouts/AllRoutes';

// import required stylesheet
import 'simplebar/dist/simplebar.min.css';
import 'tippy.js/animations/scale.css';

function App() {

    useEffect(() => {
        if (process.env.REACT_APP_ENV === "production") {
            var _mtm = window._mtm = window._mtm || [];
            _mtm.push({ 'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start' });
            var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
            g.async = true;
            g.src = process.env.REACT_APP_ENV === "development"
                ? 'https://matomo.tusker.consulting/js/container_iGGT5LS1_dev_5c6912911e05ff8b0f28c6eb.js'
                : 'https://matomo.tusker.consulting/js/container_iGGT5LS1.js';
            s.parentNode.insertBefore(g, s);
        }
    }, []);

	return (
        <HelmetProvider>
            <Router>
                <ScrollToTop />
                <AllRoutes />
            </Router>
        </HelmetProvider>
    );
}

export default App;
